import { render, staticRenderFns } from "./AsStampStatusList.vue?vue&type=template&id=c5479208"
import script from "./AsStampStatusList.vue?vue&type=script&lang=js"
export * from "./AsStampStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports